var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.386,
    height: 54.386,
    viewBox: "0 0 54.386 54.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle-outline",
    transform: "translate(0.947 74.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0.053 -73.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M52.439,26.246A26.193,26.193,0,1,0,26.246,52.439,26.2,26.2,0,0,0,52.439,26.246Z",
    transform: "translate(-0.053 -0.053)",
    fill: "none",
    stroke: "#e4004d",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M17.62,17.62.158.158",
    transform: "translate(17.304 17.304)",
    fill: "none",
    stroke: "#e4004d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M.158,17.62,17.62.158",
    transform: "translate(17.304 17.304)",
    fill: "none",
    stroke: "#e4004d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.8ae9993563c6337c990eb94132a53644.svg";
export { ForwardRef as ReactComponent };